import Alpine from 'alpinejs';

// Import all Alpine components
    // ** Core Components **
import locationAutocomplete from '@core/component/location/location-autocomplete.js';
import {forceCheckboxFalse} from "@core/force-checkbox-false.js";
import choices from '@core/component/choices/choices.js';
import datatable from '@core/component/datatable/datatable.js';
import datePicker from '@core/component/date-picker/date-picker.js';
import modal from '@core/modal.js';
import toggleCard from "@core/toggle-card.js";
import paramRename from "@core/component/param-rename/param-rename";
import syncUrlParam from "@core/component/sync-url-param/sync-url-param";
import {messageStore} from '@core/component/message/app-messages.js';
import appToastItem from '@core/component/message/app-toast-item.js';
import confirmFormAction from "@core/component/toast/confirmFormAction";
import charCounter from '@core/component/char-counter/char-counter.js';
import loadingOverlay from '@core/component/loading-overlay/loading-overlay.js';
import { insertAtCursor } from '@core/editUtils.js';


    // ** Kibe Components **
import syncDataRanges from '@module/kibe/activity/sync-data-ranges.js';
import activityCalendar from '@module/kibe/activity-calendar/activity-calendar.js';
import property from '@module/kibe/property/property.js';
import communicationModal, { communicationRecipientsTable } from "@module/kibe/communication/modal/communication-modal.js";
import previewNavigator from "@module/kibe/communication/modal/preview-navigator.js";
import platzierungsMutualExclusion from '@module/kibe/activity-type/platzierungs-types-mutual-exclusion.js';
import communicationAttachment from "@module/kibe/communication/modal/communication-attachment";
import richEditor from "@module/kibe/communication/rich-editor/rich-editor.js";
import communicationList from "@module/kibe/communication/communication-list.js";
import summaryChannelVisibility, { summaryRecipientsTable } from "@module/kibe/communication/modal/summary-channel-visibility.js";
import sendImmediateToggle from "@module/kibe/communication/modal/send-immediate-toggle.js";
import attachmentViewer from "@core/component/attachment-viewer/attachment-viewer.js";
import kibeNotifications from "@core/component/notification/notification.js";

import propertyAssignment from '@module/kibe/property-assignment/property-assignment.js';
import compositeProperty from '@module/kibe/property-assignment/composite-property.js';
import cronBuilder from '@module/kibe/property-assignment/cron-builder.js';
    // ** Portal Components **
import portalActivityCalendar from '@module/portal/activity/portal-activity-calendar.js';
import portalActivityDetailsModal from '@module/portal/activity/details-modal.js';
import portalActivityRegistrationModal from '@module/portal/activity/registration-modal.js';
import portalActivityDayToggle from '@module/portal/activity/registration-day-toggle.js';
import portalActivityMain from '@module/portal/activity/main.js';
import portalActivityMainModal from '@module/portal/activity/main-modal.js';


Alpine.store('messages', messageStore());


// Register all Alpine components
Alpine.data('syncDataRanges', syncDataRanges);
Alpine.data('activityCalendar', activityCalendar);
Alpine.data('choices', choices);
Alpine.data('datatable', datatable);
Alpine.data('datePicker', datePicker);
Alpine.data('paramRename', paramRename);
Alpine.data('syncUrlParam', syncUrlParam);
Alpine.data('locationAutocomplete', locationAutocomplete);
Alpine.data('platzierungsMutualExclusion', platzierungsMutualExclusion);
Alpine.data('forceCheckboxFalse', forceCheckboxFalse);
Alpine.data('property', property);
Alpine.data('propertyAssignment', propertyAssignment);
Alpine.data('compositeProperty', compositeProperty);
Alpine.data('cronBuilder', cronBuilder);
Alpine.data('modal', modal);
Alpine.data('communicationModal', communicationModal);
Alpine.data('previewNavigator', previewNavigator);
Alpine.data('toggleCard', toggleCard);
Alpine.data('communicationAttachment', communicationAttachment)
Alpine.data('richEditor', richEditor);
Alpine.data('communicationList', communicationList);
Alpine.data('summaryChannelVisibility', summaryChannelVisibility);
Alpine.data('sendImmediateToggle', sendImmediateToggle);
Alpine.data('attachmentViewer', attachmentViewer);
Alpine.data('kibeNotifications', kibeNotifications);
Alpine.data('communicationRecipientsTable', communicationRecipientsTable);
Alpine.data('summaryRecipientsTable', summaryRecipientsTable);
Alpine.data('portalActivityCalendar', portalActivityCalendar);
Alpine.data('appToastItem', appToastItem);
Alpine.data('charCounter', charCounter);

Alpine.data('portalActivityDetailsModal', portalActivityDetailsModal);
Alpine.data('portalActivityMain', portalActivityMain);
Alpine.data('portalActivityRegistrationModal', portalActivityRegistrationModal);
Alpine.data('portalActivityDayToggle', portalActivityDayToggle);
Alpine.data('portalActivityMainModal', portalActivityMainModal);
Alpine.data('confirmFormAction', confirmFormAction);
Alpine.data('loadingOverlay', loadingOverlay);


Alpine.magic('insertAtCursor', () => insertAtCursor);

// Start Alpine
window.Alpine = Alpine;
Alpine.start();

export default Alpine;
